import types from './actionTypes';

const initialAiState = {
  isOpen: false,
  loading: false,
  messages: [],
  error: null,
};

const initialState = {
  loading: false,
  dems: [],
  selectedDem: null,
  error: '',
  ai: initialAiState,
};

const MAX_AI_MESSAGES = 12;

const capAiConversationMessages = (messages) => {
  if (messages.length <= MAX_AI_MESSAGES) return messages;
  const cappedMessages = messages.slice(-MAX_AI_MESSAGES);
  return cappedMessages[0]?.role === 'assistant'
    ? cappedMessages.slice(1)
    : cappedMessages;
};

const demsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_DEMS_STATE:
      return initialState;

    case types.SYNC_DEMS.REQUEST:
    case types.FETCH_DEM.REQUEST:
    case types.SAVE_DEM.REQUEST:
    case types.ARCHIVE_DEM.REQUEST:
    case types.RESET_DEM_STATS.REQUEST:
      return { ...state, loading: true, error: '' };

    case types.SYNC_DEMS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        dems: [...action.dems],
      };

    case types.FETCH_DEM.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        selectedDem: action.dem,
      };

    case types.SAVE_DEM.SUCCESS:
    case types.ARCHIVE_DEM.SUCCESS:
    case types.RESET_DEM_STATS.SUCCESS:
      return { ...state, loading: false, error: '' };

    case types.SYNC_DEMS.FAILURE:
    case types.FETCH_DEM.FAILURE:
    case types.SAVE_DEM.FAILURE:
    case types.ARCHIVE_DEM.FAILURE:
    case types.RESET_DEM_STATS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };

    case types.GENERATE_AI_DEM.REQUEST: {
      const userMessageId = Date.now().toString(36) + Math.random().toString(36).slice(2);
      return {
        ...state,
        ai: {
          ...state.ai,
          loading: true,
          error: null,
          messages: [
            ...state.ai.messages,
            { id: userMessageId, role: 'user', content: action.prompt },
          ],
        },
      };
    }

    case types.GENERATE_AI_DEM.SUCCESS: {
      const assistantMessageId = Date.now().toString(36) + Math.random().toString(36).slice(2);
      const nextMessages = capAiConversationMessages([
        ...state.ai.messages,
        {
          id: assistantMessageId,
          role: 'assistant',
          content: action.message,
          design: action.design,
          designSnapshotBefore: action.designSnapshotBefore,
        },
      ]);
      return {
        ...state,
        ai: {
          ...state.ai,
          loading: false,
          error: null,
          messages: nextMessages,
        },
      };
    }

    case types.GENERATE_AI_DEM.FAILURE:
      return {
        ...state,
        ai: {
          ...state.ai,
          loading: false,
          error: action.error,
          messages: state.ai.messages.slice(0, -1),
        },
      };

    case types.TOGGLE_DEM_AI_PANEL:
      return { ...state, ai: { ...state.ai, isOpen: !state.ai.isOpen } };

    case types.RESET_DEM_AI_CONVERSATION:
      return { ...state, ai: { ...state.ai, messages: [], error: null } };

    case types.UNDO_LAST_DEM_AI_DESIGN: {
      const idx = state.ai.messages.findIndex((m) => m.id === action.messageId);
      if (idx === -1) return state;
      const hasPromptBefore = idx > 0 && state.ai.messages[idx - 1]?.role === 'user';
      const nextLength = hasPromptBefore ? idx - 1 : idx;
      return {
        ...state,
        ai: { ...state.ai, messages: state.ai.messages.slice(0, nextLength) },
      };
    }

    default:
      return state;
  }
};

export default demsReducer;
